import {
  PageHeader,
  Tag,
  Table,
  Tooltip,
  Select,
  Form,
  Row,
  Col,
  TimePicker,
  Alert,
  Empty,
  Space
} from "antd";
import React, { Component } from "react";
import {
  EyeOutlined,
  HistoryOutlined,
  CalendarOutlined,
  ClockCircleOutlined,
  AppstoreOutlined,
  BarsOutlined,
  SearchOutlined,
  ExportOutlined,
  DownOutlined,
  UpOutlined,
} from "@ant-design/icons";
import { connect } from "react-redux";

import {SelectItem, TableItemDinamico, SegmentedItem, RangePickerItem} from "../../../Components/Items"
import axios from "axios";
import moment from "moment";
import ModalVerCambios from "./ModalVerCambios/ModalVerCambios";
import ButtonItem from "../../../Components/ButtonItem";

const FORMATO_FECHA_FILTRO = "YYYY-MM-DD HH:mm:ss";

const filtrosPorDefecto = () => ({
  createdAt: {
    $gte: moment().subtract(1, "month").startOf("day").format(FORMATO_FECHA_FILTRO),
    $lte: moment().endOf("day").format(FORMATO_FECHA_FILTRO),
  },
});

const coloresAcciones = {
  AGREGAR: "green",
  EDITAR: "orange",
  CANCELAR: "red",
  ENVIAR: "purple",
  OTRO: "blue",
};

const { Option } = Select;

class Bitacora extends Component {
  formRef = React.createRef();

  state = {
    loading: false,
    registros: [],
    totalRecords: 0,
    modalVisible: false,
    cambiosSeleccionados: [],
    registroSeleccionado: null,
    registrosSinAgrupar: [],
    modoVista: 1, // 1 : Agrupados  0 : Sin agrupar
    modoHora: "dias", // "dias" | "exacto" | "franja"
    activeFilters: filtrosPorDefecto(),
    usuarios: [],
    modulosVisible: true,
    modulosActivos: [],
  };

  componentDidMount() {
    this.consultarUsuarios();
    this.consultarResumenModulos();
  }

  consultarUsuarios = async () => {
    this.setState({ loading: true });
    await axios
      .post(
        "/usuarios/selectUsuariosEmpresa",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if (res.data) {
          this.setState({
            usuarios: res.data.map((u) => (
              <Option key={u._id} value={u._id}>
                {`${u.nombre} ${u.apellidoPaterno || ""}`}
              </Option>
            )),
          });
        }
      })
      .catch((error) => {
        console.error("Error al consultar usuarios", error);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  consultarBitacora = async (params = {}) => {
    this.setState({ loading: true });

    const filtrosCombinados = {
      ...params.filters,
      ...this.state.activeFilters,
    };
    const body = {
      empresaId: this.props.empresaId,
      page: params.page || 1,
      pageSize: params.pageSize || 250,
      sortField: params.sortField || "createdAt",
      sortOrder: params.sortOrder || "descend",
      filters: filtrosCombinados || {},
    };
    axios
      .post("/bitacora/selectRegistrosBitacoraPorEmpresa", body, {
        headers: this.props.headersToken,
      })
      .then((res) => {
        if (res.data.success === 2) {
          const datosPlanos = res.data.data;

          this.setState(
            {
              registrosSinAgrupar: datosPlanos,
              totalRecords: res.data.totalRecords,
              loading: false,
            },
            () => {
              this.actualizarRegistrosVista();
            }
          );
        } else {
          console.error(res.data.message);
          this.setState({ registros: [], registrosSinAgrupar: [] });
        }
      })
      .catch((error) => {
        console.error("Error al consultar bitácora", error);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
  };

  consultarResumenModulos = async () => {
    await axios
      .post(
        "/bitacora/selectResumenModulosActivos",
        { empresaId: this.props.empresaId },
        { headers: this.props.headersToken }
      )
      .then((res) => {
        if(res.data.success === 2){
          this.setState({ modulosActivos: res.data.data });
        }
      })
      .catch((error) => {
        console.error("Error al consultar resumen de módulos", error);
      });
  };

  verCambios = (record) => {
    this.setState({
      cambiosSeleccionados: record.cambios || [],
      registroSeleccionado: record,
      modalVisible: true,
    });
  };

  handleCancelModal = () => {
    this.setState({ modalVisible: false, cambiosSeleccionados: [] });
  };

  agruparBitacoraPorFecha = (registrosPlanos) => {
    const grupos = {};

    registrosPlanos.forEach((registro) => {
      const fechaKey = moment(
        registro.fechaAgrupacion || registro.createdAt
      ).format("YYYY-MM-DD");

      if (!grupos[fechaKey]) {
        grupos[fechaKey] = {
          key: fechaKey,
          fecha: registro.fecha || fechaKey,
          count: 0,
          registrosHijos: [],
          //Desglose de acciones por tipo
          desglose: {
            AGREGAR: 0,
            EDITAR: 0,
            CANCELAR: 0,
            ENVIAR: 0,
            OTRO: 0,
          },
        };
      }

      const accionTexto = registro.accion
        ? registro.accion.toUpperCase().trim()
        : "OTRO";

      const primeraPalabra = accionTexto.split(" ")[0];

      if (
        primeraPalabra === "CREAR" ||
        primeraPalabra === "AGREGAR" ||
        primeraPalabra === "GENERAR" ||
        primeraPalabra === "REGISTRAR" ||
        primeraPalabra === "HABILITAR"
      ) {
        grupos[fechaKey].desglose.AGREGAR++;
      } else if (
        primeraPalabra === "EDITAR" ||
        primeraPalabra === "ACTUALIZAR" ||
        primeraPalabra === "CAMBIO"
      ) {
        grupos[fechaKey].desglose.EDITAR++;
      } else if (
        primeraPalabra === "CANCELAR" ||
        primeraPalabra === "BORRAR" ||
        primeraPalabra === "DESHABILITAR" ||
        primeraPalabra === "ELIMINAR"
      ) {
        grupos[fechaKey].desglose.CANCELAR++;
      } else if (primeraPalabra === "ENVIAR") {
        grupos[fechaKey].desglose.ENVIAR++;
      } else {
        grupos[fechaKey].desglose.OTRO++;
      }
      grupos[fechaKey].registrosHijos.push(registro);
      grupos[fechaKey].count++;
    });

    return Object.values(grupos);
  };

  expandedRowRender = (record) => {
    return (
      <Table
        columns={this.getColumnasInternas()}
        dataSource={record.registrosHijos}
        pagination={false}
        size="small"
        rowKey="_id"
        bordered={false}
        style={{ margin: 0 }}
      />
    );
  };
  getColumnasPrincipales = () => {
    return [
      {
        title: "Fecha",
        dataIndex: "fecha",
        key: "fecha",
        sorter: true,
        render: (text) => (
          <>
            <CalendarOutlined style={{ color: "#1890ff", marginRight: 8 }} />
            <span style={{ fontSize: 15 }}>{text}</span>
          </>
        ),
      },
      {
        title: "Resumen de Movimientos",
        dataIndex: "desglose",
        key: "desglose",
        render: (desglose, record) => {
          if (!desglose) return <Tag>{record.count}</Tag>;

          return (
            <div style={{ display: "flex", gap: "8px", alignItems: "center" }}>
              <Tooltip title="Total de movimientos en el día">
                <Tag
                  style={{
                    width: "80px",
                    textAlign: "center",
                    marginRight: 10,
                  }}
                >
                  Total: <b>{record.count}</b>
                </Tag>
              </Tooltip>

              {desglose.AGREGAR > 0 && (
                <Tooltip title={`${desglose.AGREGAR} Agregados`}>
                  <Tag color={coloresAcciones.AGREGAR}>{desglose.AGREGAR}</Tag>
                </Tooltip>
              )}

              {desglose.EDITAR > 0 && (
                <Tooltip title={`${desglose.EDITAR} Editados`}>
                  <Tag color={coloresAcciones.EDITAR}>{desglose.EDITAR}</Tag>
                </Tooltip>
              )}

              {desglose.CANCELAR > 0 && (
                <Tooltip title={`${desglose.CANCELAR} Cancelados`}>
                  <Tag color={coloresAcciones.CANCELAR}>
                    {desglose.CANCELAR}
                  </Tag>
                </Tooltip>
              )}

              {desglose.ENVIAR > 0 && (
                <Tooltip title={`${desglose.ENVIAR} Enviados`}>
                  <Tag color={coloresAcciones.ENVIAR}>{desglose.ENVIAR}</Tag>
                </Tooltip>
              )}

              {desglose.OTRO > 0 && (
                <Tooltip title={`${desglose.OTRO} Otras acciones`}>
                  <Tag color={coloresAcciones.OTRO}>{desglose.OTRO}</Tag>
                </Tooltip>
              )}
            </div>
          );
        },
      },
    ];
  };

  getColumnasInternas = () => {
    return [
      {
        title: "Hora",
        dataIndex: "hora",
        key: "hora",
        width: 50,
        render: (text) => <span style={{ color: "#666" }}>{text}</span>,
      },
      {
        title: "Usuario",
        dataIndex: "usuarioNombre",
        key: "usuarioNombre",
        width: 180,
        render: (text) => <b>{text}</b>,
      },
      {
        title: "Módulo",
        dataIndex: "modelo",
        key: "modelo",
        width: 90,
        render: (text) => (
          <Tooltip title="Filtrar por este módulo">
            <Tag
              color="geekblue"
              style={{ cursor: "pointer" }}
              onClick={() => this.filtrarPorModulo(text)}
            >
              {text}
            </Tag>
          </Tooltip>
        ),
      },
      {
        title: "Acción",
        dataIndex: "accion",
        key: "accion",
        render: (text, record) => {
          let color = coloresAcciones.OTRO;

          const accionTexto = record.accion
            ? record.accion.toUpperCase().trim()
            : "";

          const primeraPalabra = accionTexto.split(" ")[0];

          if (
            primeraPalabra === "CREAR" ||
            primeraPalabra === "AGREGAR" ||
            primeraPalabra === "GENERAR" ||
            primeraPalabra === "REGISTRAR" ||
            primeraPalabra === "HABILITAR"
          ) {
            color = coloresAcciones.AGREGAR;
          } else if (
            primeraPalabra === "EDITAR" ||
            primeraPalabra === "ACTUALIZAR" ||
            primeraPalabra === "CAMBIO"
          ) {
            color = coloresAcciones.EDITAR;
          } else if (primeraPalabra === "ENVIAR") {
            color = coloresAcciones.ENVIAR;
          } else if (
            primeraPalabra === "CANCELAR" ||
            primeraPalabra === "BORRAR" ||
            primeraPalabra === "DESHABILITAR" ||
            primeraPalabra === "ELIMINAR"
          ) {
            color = coloresAcciones.CANCELAR;
          }

          return <Tag color={color}>{record.accion}</Tag>;
        },
      },
      {
        title: "Detalles",
        dataIndex: "detalles",
        key: "detalles",
        render: (text, record) => (
          <div
            style={{
              whiteSpace: "normal",
              wordWrap: "break-word",
              maxWidth: "300px",
            }}
          >
            {text}
          </div>
        ),
      },
      {
        title: "Acciones",
        key: "acciones",
        width: 100,
        align: "center",
        render: (text, record) => {
          let buttons = [];
          if(record.cambios && record.cambios.length){
            buttons.push(
              <Tooltip title="Ver cambios detallados">
                <ButtonItem
                  type="dashed"
                  shape="circle"
                  size="small"
                  icon={<EyeOutlined />}
                  onClick={() => this.verCambios(record)}
                />
              </Tooltip>
            );
          }
          const renderBotonIr = (ruta, extraState = {}) =>
            buttons.push(
              <Tooltip title={`Ir a ${record.modelo}`} key="btn-ir">
                <ButtonItem
                  type="primary"
                  shape="circle"
                  size="small"
                  icon={<ExportOutlined />}
                  onClick={() => {
                    this.props.history.push(ruta, { id: record.modeloId, ...extraState });
                    //Ejemplo de ruta
                    //this.props.history.push("/panel/verVenta", { id: record._id });
                  }}
                />
              </Tooltip>
            );

          switch (record.modelo) {
            case "Venta":
              renderBotonIr("verVenta");
              break;
            case "Pedido":
              renderBotonIr("verPedido");
              break;
            case "Cotizacion":
              renderBotonIr("verCotizacion");
              break;
            case "Cliente":
              renderBotonIr("editarCliente");
              break;
            case "Proveedor":
              renderBotonIr("editarProveedor");
              break;
            case "Empresa":
              renderBotonIr("configuracion");
              break;
            case "Insumo":
              renderBotonIr("editarInsumo");
              break;
            case "Requisición":
              renderBotonIr("verRequisicion");
              break;
            case "Workbench Requisiciones":
              renderBotonIr("editarRequisicion", { workbench: true });
              break;
            case "Orden de Compra":
              renderBotonIr("verOrdenDeCompra");
              break;
            case "Comodato":
              renderBotonIr("verOrdenComodato");
              break;
            case "Factura de Caja Chica":
              renderBotonIr("verFacturaCajaChica");
              break;
            case "Factura Sin Orden De Compra":
              renderBotonIr("verFacturaSinOrdenDeCompra");
              break;
            case "Orden de Maquila":
              renderBotonIr("vistaOrdenDeMaquila", { modo: "ver" });
              break;
            default:
              <Tag>N/A</Tag>;
              break;
          }

           return <Space direction="horizontal">{buttons}</Space>;
        },
      },
    ];
  };

  getColumnasSinAgrupar = () => {
    const columnas = this.getColumnasInternas();
    return [
      {
        title: "Fecha",
        dataIndex: "fecha",
        key: "fecha",
        width: 120,
        render: (text) => (
          <span style={{ color: "#1890ff", fontWeight: 500 }}>{text}</span>
        ),
      },
      ...columnas,
    ];
  };

  handleChangeModoVista = (value) => {
    this.setState({ modoVista: parseInt(value) }, () => {
      this.actualizarRegistrosVista();
    });
  };

  actualizarRegistrosVista = () => {
    const { modoVista, registrosSinAgrupar } = this.state;

    if (modoVista === 1) {
      const agrupados = this.agruparBitacoraPorFecha(registrosSinAgrupar);
      this.setState({ registros: agrupados });
    } else {
      this.setState({ registros: registrosSinAgrupar });
    }
  };

  refrescarTabla = () => {
    if (this.tableRef) {
      this.tableRef.updateExternalFilters({});
    } else {
      this.consultarBitacora({ page: 1 });
    }
  };

  onFinishFilters = (values) => {
    const { modoHora } = this.state;
    const filtros = {};

    if (values.periodo && values.periodo.length === 2) {
      const [inicio, fin] = values.periodo;
      filtros.createdAt =
        modoHora === "exacto"
          ? {
              $gte: inicio.clone().startOf("minute").format(FORMATO_FECHA_FILTRO),
              $lte: fin.clone().endOf("minute").format(FORMATO_FECHA_FILTRO),
            }
          : {
              $gte: inicio.clone().startOf("day").format(FORMATO_FECHA_FILTRO),
              $lte: fin.clone().endOf("day").format(FORMATO_FECHA_FILTRO),
            };
    }

    if (modoHora === "franja" && values.franja && values.franja.length === 2) {
      filtros.franjaHoraria = {
        inicio: values.franja[0].hours() * 60 + values.franja[0].minutes(),
        fin: values.franja[1].hours() * 60 + values.franja[1].minutes(),
      };
    }

    // Filtro por usuario
    if (values.usuarios && values.usuarios.length > 0) {
      filtros.usuarioId = { $in: values.usuarios };
    }

    // Filtro por módulo y sus acciones
    if (values.modelo) {
      filtros.modelo = values.modelo;
      if (values.acciones && values.acciones.length > 0) {
        filtros.accion = { $in: values.acciones };
      }
    }

    this.setState({ activeFilters: filtros }, this.refrescarTabla);
  };

  // Click en el tag de módulo de la tabla
  filtrarPorModulo = (modelo) => {
    if (!this.formRef.current) return;
    const moduloActual = this.formRef.current.getFieldValue("modelo");
    this.formRef.current.setFieldsValue({
      modelo,
      acciones: moduloActual === modelo ? this.formRef.current.getFieldValue("acciones") : [],
    });
    this.formRef.current.submit();
  };

  limpiarFiltros = () => {
    this.setState({ modoHora: "dias", activeFilters: filtrosPorDefecto() });
    if (this.formRef.current) {
      this.formRef.current.resetFields();
    }
  };


  renderModulosActivos = () => {
    const { modulosActivos, modulosVisible } = this.state; 
    const fechaInicioBitacora = "10/12/2025"; 

    if (!modulosActivos || modulosActivos.length === 0) return null;

    const listaOrdenada = modulosActivos
      .map((m) => m.modelo)
      .filter(Boolean)
      .sort();

    return (
      <div
        style={{
          marginTop: 20,
          border: "1px solid #d9d9d9",
          borderRadius: "6px",
          overflow: "hidden",
        }}
      >
        <div
          onClick={() => this.setState({ modulosVisible: !modulosVisible })} 
          style={{
            backgroundColor: "#fafafa",
            padding: "10px 15px",
            borderBottom: modulosVisible ? "1px solid #d9d9d9" : "none",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            cursor: "pointer", 
            transition: "all 0.3s",
            userSelect: "none" 
          }}
        >
          <div style={{ display: "flex", alignItems: "center" }}>
            {modulosVisible ? (
              <UpOutlined style={{ marginRight: 10, fontSize: "12px", color: "#8c8c8c" }} />
            ) : (
              <DownOutlined style={{ marginRight: 10, fontSize: "12px", color: "#8c8c8c" }} />
            )}
            
            <span style={{ fontWeight: "600", color: "#262626", fontSize: "14px" }}>
              <AppstoreOutlined style={{ marginRight: 6, color: "#1890ff" }} />
              Módulos monitoreados
            </span>
          </div>

          {fechaInicioBitacora && (
            <span
              style={{
                color: "#595959",
                fontSize: "13px",
                backgroundColor: "#fff",
                padding: "2px 8px",
                borderRadius: "4px",
                border: "1px solid #f0f0f0",
              }}
              onClick={(e) => e.stopPropagation()} 
            >
              <CalendarOutlined style={{ marginRight: 6, color: "#8c8c8c" }} />
              Activa desde: <b>{moment(fechaInicioBitacora).format("DD/MM/YYYY")}</b>
            </span>
          )}
        </div>

        {modulosVisible && (
          <div
            style={{
              padding: "15px",
              backgroundColor: "white",
              display: "grid",
              gridTemplateColumns: "repeat(auto-fill, minmax(160px, 1fr))",
              gap: "10px",
              animation: "fadeIn 0.3s ease-in-out"
            }}
          >
            {listaOrdenada.map((modulo) => (
              <div
                key={modulo}
                onClick={() => this.filtrarPorModulo(modulo)}
                style={{
                  display: "flex",
                  alignItems: "center",
                  padding: "6px 10px",
                  backgroundColor: "#f0f5ff",
                  border: "1px solid #adc6ff",
                  borderRadius: "4px",
                  color: "#2f54eb",
                  fontSize: "13px",
                  fontWeight: "500",
                  whiteSpace: "nowrap",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                  cursor: "pointer",
                }}
                title={`Filtrar por ${modulo}`}
              >
                 <span
                  style={{
                    height: "6px",
                    width: "6px",
                    backgroundColor: "#2f54eb",
                    borderRadius: "50%",
                    marginRight: "8px",
                    flexShrink: 0,
                  }}
                />
                {modulo}
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

 
  render() {
    const {
      modalVisible,
      cambiosSeleccionados,
      registroSeleccionado,
      modoVista,
      modoHora,
      totalRecords,
      registrosSinAgrupar,
    } = this.state;

    return (
      <>
        <PageHeader
          title={
            <span>
              <HistoryOutlined /> Bitácora de Actividad
            </span>
          }
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
        />
        <div
          style={{
            backgroundColor: "white",
            padding: "15px 20px",
            border: "1px solid rgb(235, 237, 240)",
            marginBottom: 10,
            borderRadius: 4,
          }}
        >
          <Form
            ref={this.formRef}
            layout="vertical"
            onFinish={this.onFinishFilters}
            initialValues={{
              periodo: [moment().subtract(1, "month"), moment()],
            }}
          >
            <Row gutter={16} align="bottom">
              <Col xs={24} sm={12} md={7}>
                <Form.Item
                  label={
                    <span>
                      <CalendarOutlined /> Rango de Fechas
                    </span>
                  }
                  name="periodo"
                  style={{ marginBottom: 10 }}
                >
                  <RangePickerItem
                    style={{ width: "100%" }}
                    format={modoHora === "exacto" ? "DD/MM/YYYY HH:mm" : "DD/MM/YYYY"}
                    showTime={modoHora === "exacto" ? { format: "HH:mm" } : false}
                    placeholder={["Inicio", "Fin"]}
                    ranges={{
                      "Hoy": [moment().startOf("day"), moment().endOf("day")],
                      "Últimas 24 hrs": [moment().subtract(24, "hours"), moment()],
                      "Últimos 7 días": [moment().subtract(7, "days"), moment()],
                      "Últimos 30 días": [moment().subtract(30, "days"), moment()],
                      "Este mes": [moment().startOf("month"), moment().endOf("month")],
                    }}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={6}>
                <Form.Item
                  label={
                    <span>
                      <ClockCircleOutlined /> Horas
                    </span>
                  }
                  style={{ marginBottom: 10 }}
                >
                  <SegmentedItem
                    options={[
                      { label: "Días completos", value: "dias" },
                      { label: "Fecha y hora", value: "exacto" },
                      { label: "Franja", value: "franja" },
                    ]}
                    value={modoHora}
                    onChange={(value) => this.setState({ modoHora: value })}
                  />
                </Form.Item>
              </Col>

              {modoHora === "franja" && (
                <Col xs={24} sm={12} md={5}>
                  <Form.Item
                    label="Franja horaria (cada día)"
                    name="franja"
                    style={{ marginBottom: 10 }}
                  >
                    <TimePicker.RangePicker
                      style={{ width: "100%" }}
                      format="HH:mm"
                      minuteStep={5}
                      order={false}
                      placeholder={["Desde", "Hasta"]}
                    />
                  </Form.Item>
                </Col>
              )}

              <Col xs={24} sm={12} md={5}>
                <Form.Item
                  label="Módulo"
                  name="modelo"
                  style={{ marginBottom: 10 }}
                >
                  <SelectItem
                    placeholder="Todos los módulos"
                    style={{ width: "100%" }}
                    allowClear
                    showSearch
                    optionFilterProp="children"
                    onChange={() => {
                      if (this.formRef.current) {
                        this.formRef.current.setFieldsValue({ acciones: [] });
                        this.formRef.current.submit();
                      }
                    }}
                  >
                    {this.state.modulosActivos.map((m) => (
                      <Option key={m.modelo} value={m.modelo}>
                        {m.modelo}
                      </Option>
                    ))}
                  </SelectItem>
                </Form.Item>
              </Col>

              <Form.Item
                noStyle
                shouldUpdate={(prev, cur) => prev.modelo !== cur.modelo}
              >
                {({ getFieldValue }) => {
                  const moduloSel = getFieldValue("modelo");
                  const moduloData = this.state.modulosActivos.find(
                    (m) => m.modelo === moduloSel
                  );
                  const acciones = (moduloData && moduloData.acciones) || [];

                  return (
                    <Col xs={24} sm={12} md={6}>
                      <Form.Item
                        label="Acciones del módulo"
                        name="acciones"
                        style={{ marginBottom: 10 }}
                      >
                        <SelectItem
                          mode="multiple"
                          placeholder={
                            moduloSel
                              ? "Todas las acciones"
                              : "Elige un módulo primero"
                          }
                          style={{ width: "100%" }}
                          maxTagCount="responsive"
                          allowClear
                          disabled={!moduloSel}
                          onChange={() =>
                            this.formRef.current && this.formRef.current.submit()
                          }
                        >
                          {acciones.map((accion) => (
                            <Option key={accion} value={accion}>
                              {accion}
                            </Option>
                          ))}
                        </SelectItem>
                      </Form.Item>
                    </Col>
                  );
                }}
              </Form.Item>

              <Col xs={24} sm={12} md={6}>
                <Form.Item
                  label="Filtrar por Usuarios"
                  name="usuarios"
                  style={{ marginBottom: 10 }}
                >
                  <SelectItem
                    mode="multiple"
                    placeholder="Seleccione usuarios"
                    style={{ width: "100%" }}
                    maxTagCount="responsive"
                    allowClear
                  >
                    {this.state.usuarios}

                  </SelectItem>
                </Form.Item>
              </Col>

              <Col xs={24} sm={12} md={5}>
                <Form.Item label="Vista" style={{ marginBottom: 10 }}>
                  <SegmentedItem
                    options={[
                      { label: "Agrupado", value: 1, icon: <AppstoreOutlined /> },
                      { label: "Listado", value: 0, icon: <BarsOutlined /> },
                    ]}
                    value={modoVista}
                    onChange={this.handleChangeModoVista}
                  />
                </Form.Item>
              </Col>

              <Col xs={24} md={4}>
                <Form.Item style={{ marginBottom: 10 }}>
                  <ButtonItem
                    type="primary"
                    htmlType="submit"
                    icon={<SearchOutlined />}
                    block
                  >
                    Consultar
                  </ButtonItem>
                </Form.Item>
              </Col>
            </Row>
          </Form>
          {this.renderModulosActivos()}
        </div>

        {modoVista === 1 && totalRecords > registrosSinAgrupar.length && (
          <Alert
            type="info"
            showIcon
            style={{ marginBottom: 10 }}
            message={`El resumen por día se calcula sobre los ${registrosSinAgrupar.length} registros de esta página (${totalRecords} en total). El primer y último día de la página pueden verse incompletos — usa el paginador o acota el rango de fechas.`}
          />
        )}

        <TableItemDinamico
          onRef={(ref) => (this.tableRef = ref)}
          totalRecords={this.state.totalRecords}
          loading={this.state.loading}
          dataSource={this.state.registros}
          columns={
            modoVista === 1
              ? this.getColumnasPrincipales()
              : this.getColumnasSinAgrupar()
          }
          onFetchData={this.consultarBitacora}
          defaultPageSize={250}
          onClearFilters={this.limpiarFiltros}
          size="small"
          rowKey={modoVista === 1 ? "key" : "_id"}
          locale={{
            emptyText: (
              <Empty
                image={Empty.PRESENTED_IMAGE_SIMPLE}
                description="Sin registros disponibles"
              />
            ),
          }}
          expandable={
            modoVista === 1
              ? {
                  expandedRowRender: this.expandedRowRender,

                  rowExpandable: (record) => record.count > 0,
                }
              : undefined
          }
        />

        <ModalVerCambios
          visible={modalVisible}
          onCancel={this.handleCancelModal}
          registro={registroSeleccionado}
          cambios={cambiosSeleccionados}
        />
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    headersToken: state.user.headersToken,
    empresaId: state.empresa.id,
  };
};
export default connect(mapStateToProps, {})(Bitacora);
